<div class="modal-overlay" *ngIf="isVisible" (click)="onOverlayClick($event)">
  <div class="modal-container">
    <button class="close-button" (click)="onCancel()" [disabled]="data.isLoading">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    
    <!-- Illustration Section -->
    <div class="illustration-section" *ngIf="data.imageSrc">
      <div class="illustration-container">
        <img [src]="data.imageSrc" [alt]="data.imageAlt || 'Confirmation illustration'" class="illustration-image">
      </div>
    </div>
    
    <!-- Content Section -->
    <div class="content-section">
      <h2 class="modal-title">{{ data.title }}</h2>
      <p class="modal-description">{{ data.description }}</p>
      <div class="time-info-badge" *ngIf="data.showTimeInfo && data.timeInfo">
        <div class="time-info-content">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="8.33333" stroke="#B85900" stroke-width="1.5"/>
            <path d="M10 6.66667V10L12.5 12.5" stroke="#B85900" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="time-info-text">{{ data.timeInfo }}</span>
        </div>
      </div>
    </div>
    
    <!-- Action Buttons Section -->
    <div class="actions-section" *ngIf="showCancelButton || showConfirmButton">
      <button class="cancel-button" (click)="onCancel()" *ngIf="showCancelButton" [disabled]="data.isLoading">
        {{ data.cancelText || 'Cancel' }}
      </button>
      <button class="confirm-button" (click)="onConfirm()" *ngIf="showConfirmButton" [disabled]="data.isLoading">
        <span *ngIf="!data.isLoading">{{ data.confirmText || 'Confirm' }}</span>
        <span *ngIf="data.isLoading" class="loading-text">Processing...</span>
      </button>
    </div>
  </div>
</div>
